import { render } from "./siteMetaConfig.vue?vue&type=template&id=456d92d4&scoped=true"
import script from "./siteMetaConfig.vue?vue&type=script&lang=js"
export * from "./siteMetaConfig.vue?vue&type=script&lang=js"

import "./siteMetaConfig.vue?vue&type=style&index=0&id=456d92d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456d92d4"]])

export default __exports__